/* Native Shopify customer form handles subscription. No email is stored locally. */
if (!customElements.get('mshu-campaign')) {
  customElements.define('mshu-campaign', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.setup(); });
    }
    setup() {
      this.abort?.abort();
      clearTimeout(this.timer);
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.editor = Boolean(window.Shopify?.designMode);
      this.storageKey = `mshu:campaign:${this.dataset.campaign}`;
      this.pendingKey = 'mshu:signup-pending';
      this.previousFocus = null;
      this.attempts = 0;
      this.querySelector('[data-popup-launcher]').hidden = false;
      this.querySelector('[data-popup-open]').addEventListener('click', () => this.open(), { signal });
      this.querySelector('[data-popup-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        if (!this.editor) this.write('localStorage', this.storageKey, String(Date.now()));
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }, { signal });
      const readyButton = this.querySelector('[data-popup-submit]');
      if (readyButton && !this.submitting) {
        readyButton.removeAttribute('aria-disabled');
        readyButton.textContent = readyButton.dataset.readyLabel;
      }
      const form = this.querySelector('form');
      if (form) form.addEventListener('submit', (event) => {
        if (this.editor) {
          event.preventDefault();
          this.querySelector('[data-popup-editor-status]').textContent = '编辑器预览不会提交邮箱。请在店铺预览中测试实际订阅。';
          return;
        }
        if (this.submitting) { event.preventDefault(); return; }
        this.submitting = true;
        this.write('sessionStorage', this.pendingKey, JSON.stringify({ campaign: this.dataset.campaign, at: Date.now() }));
        const button = this.querySelector('[data-popup-submit]');
        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.textContent = button.dataset.loadingLabel;
        }
        // Allow the browser to submit the original Shopify form, including CAPTCHA.
      }, { signal });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) { this.submitting = false; this.setup(); }
      }, { signal });
      if (this.editor) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.open();
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
        }, { signal });
        if (this.dataset.editorPreview === 'true') this.open();
        return;
      }
      const result = this.querySelector('[data-popup-result]')?.dataset.popupResult;
      const pending = this.pending();
      const hashMatches = window.location.hash === `#MshuSignup-${this.dataset.sectionId}`;
      if (result && (pending || hashMatches)) {
        this.remove('sessionStorage', this.pendingKey);
        if (result === 'success') this.write('localStorage', 'mshu:email-submitted', 'true');
        this.open();
        this.querySelector('[data-popup-result]')?.focus({ preventScroll: true });
        return;
      }
      if (this.dataset.mode === 'signup' && (this.dataset.subscribed === 'true' || this.read('localStorage', 'mshu:email-submitted') === 'true')) return;
      const dismissed = Number(this.read('localStorage', this.storageKey) || 0);
      if (dismissed && Date.now() - dismissed < Number(this.dataset.days) * 86400000) return;
      this.timer = setTimeout(() => this.autoOpen(), Number(this.dataset.delay) * 1000);
    }
    pending() {
      try {
        const value = JSON.parse(this.read('sessionStorage', this.pendingKey) || 'null');
        return value?.campaign === this.dataset.campaign && Date.now() - value.at < 1800000;
      } catch { return false; }
    }
    autoOpen() {
      if (!this.isConnected || this.dialog.open) return;
      const otherDialog = document.querySelector('dialog[open], cart-drawer.active, cart-notification.active, details[open] .menu-drawer');
      const typing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      if (document.hidden || otherDialog || typing) {
        if (++this.attempts < 60) this.timer = setTimeout(() => this.autoOpen(), 1000);
        return;
      }
      this.open();
    }
    open() {
      clearTimeout(this.timer);
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
    }
    read(storage, key) { try { return window[storage].getItem(key); } catch { return null; } }
    write(storage, key, value) { try { window[storage].setItem(key, value); } catch { /* Storage can be blocked. */ } }
    remove(storage, key) { try { window[storage].removeItem(key); } catch { /* Storage can be blocked. */ } }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
